import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createInvoicingProductsSchemas } from 'shared/db/validation/schema/invoicingProducts';
import { Validator } from 'shared/db/validation/validator';
import {
    InvoicingProductRawRecord,
    InvoicingProductUpdateRawRecord,
} from 'shared/types/Products';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { InvoicingProductsDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createInvoicingProductsSchemas();

const addValidator = createDBEntityValidator<InvoicingProductRawRecord>(
    schemas.add as Parameters<
        typeof createDBEntityValidator<InvoicingProductRawRecord>
    >[0],
);
const updateValidator =
    createDBEntityValidator<InvoicingProductUpdateRawRecord>(
        schemas.update as Parameters<
            typeof createDBEntityValidator<InvoicingProductUpdateRawRecord>
        >[0],
    );
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-invoicing-products'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createInvoicingProductsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const invoicingProductsInputValidation: InvoicingProductsDBValidation = {
    add: createInvoicingProductsInputValidation(
        addValidator,
        validationStrategy,
    ),
    update: createInvoicingProductsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createInvoicingProductsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
